import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 40.368a3 3 0 0 0 2.737 2.989Q18.044 44 24.023 44q5.972 0 13.241-.642A3 3 0 0 0 40 40.37V12a2 2 0 0 0-2-2H10a4 4 0 0 1-2-.535zM10 2h28a4 4 0 0 1 4 4 1 1 0 1 1-2 0 2 2 0 0 0-2-2H10a2 2 0 1 0 0 4h28a4 4 0 0 1 4 4v28.37a5 5 0 0 1-4.56 4.98q-7.353.65-13.417.65-6.072 0-13.462-.651A5 5 0 0 1 6 40.369V6a4 4 0 0 1 4-4m14 36q3.967 0 7.937-.888a2.343 2.343 0 0 0 1.643-3.207l-.683-1.6a3 3 0 0 0-2.249-1.778Q27.598 30.001 24 30q-3.597 0-6.648.527a3 3 0 0 0-2.249 1.778l-.683 1.6a2.343 2.343 0 0 0 1.643 3.207Q20.033 38 24 38m0 2a38.3 38.3 0 0 1-8.373-.936 4.34 4.34 0 0 1-3.047-5.944l.684-1.6a5 5 0 0 1 3.747-2.964Q20.237 28 24 28t6.989.556a5 5 0 0 1 3.747 2.964l.684 1.6q.157.368.244.758a4.343 4.343 0 0 1-3.29 5.186A38.3 38.3 0 0 1 24 40m-4-20c0 2.206 1.793 4 4 4s4-1.793 4-4-1.793-4-4-4-4 1.793-4 4m-2 0c0-3.312 2.69-6 6-6 3.312 0 6 2.69 6 6 0 3.312-2.69 6-6 6-3.312 0-6-2.69-6-6",
      clipRule: "evenodd"
    }
  )
);
var SvgContactsOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ContactsOutlined_default = SvgContactsOutlined;

export { ContactsOutlined_default as default };
